import { useLocation } from 'react-router-dom'

const useVersion = () => {
  const { pathname } = useLocation()

  const version = pathname.match(/\/events\/(\d{4})/)?.[1] || 2025
  const isEventPage = pathname.includes('events')

  return { version: Number(version), isEventPage }
}

export default useVersion
